import { Input, Modal, Table } from "antd"
import { useState } from "react"
import VSpace from "../../common/VSpace"
import { useQboItems } from "../../../domain/costCodes/costCodeQueries"
import { QboItem } from "../../../domain/costCodes/costCodesApi"

export type Props = {
  open: boolean
  onSubmit: (qboId?: string, qboDisplayName?: string) => void
  onCancel: () => void
}

const LinkCostCodeModal = ({ open, onSubmit, onCancel }: Props) => {
  const qboItems = useQboItems()
  const [search, setSearch] = useState('')
  const [selectedItem, setSelectedItem] = useState<QboItem | undefined>()

  const items = qboItems.data?.filter(x => x.displayName.toLowerCase().includes(search.toLowerCase())) ?? []

  return <Modal
    open={open}
    title="Link Cost Code to QuickBooks Online"
    onOk={() => onSubmit(selectedItem?.id, selectedItem?.displayName)}
    onCancel={onCancel}
  >
    <VSpace>
      <Input.Search value={search} onChange={e => setSearch(e.target.value)} />
      <Table
        dataSource={items}
        rowKey="id"
        scroll={{ y: 400 }}
        style={{ height: 400 }}
        pagination={false}
        columns={[
          {
            dataIndex: 'displayName',
          }
        ]}
        showHeader={false}
        rowSelection={{
          selectedRowKeys: selectedItem ? [selectedItem.id] : [],
          type: 'radio',
          onChange: (keys) => {
            const item = items.find(x => keys.includes(x.id))
            setSelectedItem(item)
          },
          renderCell: () => '',
          columnWidth: 0,
        }}
        onRow={(record) => ({
          onClick: () => setSelectedItem(record)
        })}
      />
    </VSpace>
  </Modal>
}

export default LinkCostCodeModal
